export type SessionBrowserKind = 'chrome' | 'edge' | 'other' | 'safari';

export function resolveSessionBrowser(labelSource: string): SessionBrowserKind {
  const source = labelSource.toLowerCase();
  if (source.includes('edg')) {
    return 'edge';
  }
  if (source.includes('chrome') || source.includes('crios') || source.includes('chromium')) {
    return 'chrome';
  }
  if (source.includes('safari') || source.includes('iphone') || source.includes('ipad')) {
    return 'safari';
  }
  return 'other';
}

export function resolveSessionLabel(name?: string | null, userAgent?: string | null): string | null {
  const trimmedName = name?.trim();
  if (trimmedName) {
    return trimmedName;
  }
  return parseUserAgentLabel(userAgent);
}

function parseUserAgentLabel(userAgent?: string | null): string | null {
  if (!userAgent) {
    return null;
  }
  const browser = resolveSessionBrowser(userAgent);
  const browserLabel = browserLabelForKind(browser);
  const osLabel = parseOsLabel(userAgent);
  if (browserLabel && osLabel) {
    return `${browserLabel} on ${osLabel}`;
  }
  return browserLabel;
}

function browserLabelForKind(kind: SessionBrowserKind): string | null {
  switch (kind) {
    case 'chrome':
      return 'Chrome';
    case 'edge':
      return 'Edge';
    case 'safari':
      return 'Safari';
    case 'other':
      return null;
    default: {
      const exhaustive: never = kind;
      return exhaustive;
    }
  }
}

function parseOsLabel(userAgent: string): string | null {
  const source = userAgent.toLowerCase();
  if (source.includes('mac os') || source.includes('macintosh')) {
    return 'Mac OS X';
  }
  if (source.includes('iphone')) {
    return 'iPhone';
  }
  if (source.includes('ipad')) {
    return 'iPad';
  }
  if (source.includes('android')) {
    return 'Android';
  }
  if (source.includes('windows')) {
    return 'Windows';
  }
  if (source.includes('linux')) {
    return 'Linux';
  }
  return null;
}
